import { useParams } from 'next/navigation'
import { useMemo } from 'react'

import type { CatalogSeoLinks } from '@/features/catalog/catalog-initial-data'
import { useCatalogInitialData } from '@/features/catalog/catalog-initial-data'

import { catalogApiSlice, SeoLink } from '@/entities/catalog-old'

import { getSeoLinkUri } from '@/shared/lib/utils/url/get-seo-uri'
import { isParameterCatalogUrl } from '@/shared/lib/utils/url/isParametrCatalogUrl'

export const useSeoLinks = (place: 'top' | 'bottom') => {
	const params = useParams()
	const slugParam = params?.slug as string | string[] | undefined
	const slug = (Array.isArray(slugParam) ? slugParam : [slugParam]).filter(Boolean) as string[]
	const isParameterUrl = isParameterCatalogUrl(`/catalog/${slug?.join(`/`)}/`)
	const uri = getSeoLinkUri(slug, isParameterUrl)
	const { initialSeoLinks } = useCatalogInitialData()
	const linkKey: keyof CatalogSeoLinks = `RELATED_LINK_${place.toUpperCase()}` as keyof CatalogSeoLinks
	const initialLinks = useMemo(() => initialSeoLinks?.[linkKey] || null, [initialSeoLinks, linkKey])

	const { data, isFetching } = catalogApiSlice.useGetSeoLinksQuery(
		{ uri },
		{
			skip: !!initialLinks
		}
	)
	const seoLinks = useMemo(() => initialLinks || (data?.[linkKey] as SeoLink[]), [data, initialLinks, linkKey])

	return {
		seoLinks,
		isLoading: isFetching
	}
}
